// ---- LAYER EXTENSION SEAM (frontend) ----------------------------------------
// This file is LAYER-OWNED: in a rented-kit deployment the customer's layer
// repo overlays it (see docs/layer-contract.md). The kit ships empty exports
// so a bare kit builds identically with or without a layer.
//
// Contract (keep shapes stable — App.js / Navbar map these blindly):
//   extRoutes: [{ path, element, public?: boolean }]
//     Mounted inside the kit's <Routes>. Non-public routes are wrapped in
//     the kit's RequireAuth. Keep paths under /ext/… or your own product
//     namespace — never shadow kit routes (/, /login, /dev, /jobs, /items).
//   extNav: [{ to, label }]
//     Extra links appended to the kit Navbar for signed-in members.
//
// Example (layer repo):
//   import MyDashboard from './MyDashboard';
//   export const extRoutes = [{ path: '/dashboard', element: <MyDashboard /> }];
//   export const extNav = [{ to: '/dashboard', label: 'Dashboard' }];

export const extRoutes = [];
export const extNav = [];
